export default "/images/vendor/flag-icon-css/flags/1x1/ec.svg?33ce56273543deb46e2cdb7663a89421";